import Row from '../display/Row';
import Line from '../display/Line';
import Sbl from '../display/Sbl';
import Double from '../display/Double';
import FreeSpins from '../display/FreeSpins';
import WinWindow from '../display/WinWindow';

export default class MainScreen {
  constructor({ scatter, demo }, lib) {
    this.scatter = scatter;
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.initView(demo, lib);
  }

  initView(demo, lib) {
    this.view = new lib.MainScreen();
    this.view.demoText.visible = demo;

    this.freeSpins = new FreeSpins(this.view.freeSpins);
    this.winWindow = new WinWindow(this.view.winWindow);
    this.rows = Array.from({ length: 3 }, (el, i) => new Row(this.view[`row${i}`]));
    this.lines = Array.from({ length: 9 }, (el, i) => new Line(this.view[`line${i}`]));
    this.doubles = Array.from({ length: 5 }, (el, i) => new Double(this.view[`x${2 ** (i + 1)}`], i));
    this.symbols = Array.from({ length: 15 }, (el, i) =>
      new Sbl(lib, this.view.symbolsContainer, i));
  }

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  }

  play({ win, spinWin, scatterWin, symbols, lines, freeSpins, freeSpinsDone }, winSymbols) {
    this.stop();
    this.hideSymbols();
    this.winWindow.hide();
    this.freeSpins.updateBeforePlay(freeSpins, freeSpinsDone);

    return this.playSymbols(symbols)
      .then(() => {
        this.showWinLines(lines);
        this.showScatterWin(scatterWin);
        this.showWinSymbols(winSymbols);
      })
      .then(() => this.winWindow.show(spinWin))
      .then(() => this.freeSpins.updateAfterPlay(freeSpins, freeSpinsDone, win));
  }

  stop() {
    this.stopSymbols();
    this.hideWinLines();

    this.doubles.forEach((double) => {
      double.view.removeAllEventListeners('click');
      double.reset();
    });
  }

  showFreeSpinsLeft(freeSpins, freeSpinsDone) {
    return this.freeSpins.showFreeSpinsLeft(freeSpins, freeSpinsDone);
  }

  showWinSymbols(winSymbols) {
    this.symbols.forEach((symbol, i) => !!winSymbols[i] && symbol.playWin());
  }

  stopSymbols() {
    this.symbols.forEach(symbol => symbol.stop());
  }

  hideSymbols() {
    this.rows.forEach(row => row.hide());
    this.symbols.forEach(symbol => symbol.hide());
  }

  playSymbols(symbolsId) {
    return this.symbols.reduce((acc, symbol, i) =>
      acc.then(() => this.playSymbol(symbol, symbolsId[i], i)), Promise.resolve());
  }

  playSymbol(symbol, id, i) {
    if (i % 5 === 0) {
      this.rows[Math.floor(i / 5)].show();
    }
    return symbol.play(id);
  }

  showScatterWin(win) {
    if (win) {
      this.symbols.forEach(symbol => symbol.id === this.scatter && symbol.playWin());
    }
  }

  showDouble(step) {
    const double = this.doubles[step];
    double.play();
    double.view.addEventListener('click', () => this.eventDispatcher.dispatchEvent('play-double'));
  }

  playDouble(win, step) {
    const double = this.doubles[step];
    double.showWin(win);
    double.view.removeAllEventListeners('click');

    if (!win) {
      this.stopSymbols();
      this.hideWinLines();
    }

    return this.winWindow.hide().then(() => this.winWindow.show(win));
  }

  showLines(lines) {
    this.lines.forEach((line, i) => line.setVisible(lines > i));
  }

  showWinLines(lines) {
    this.lines.forEach((line, i) => lines[i] && line.showWin());
  }

  hideWinLines() {
    this.lines.forEach(line => line.hide());
  }
}



// WEBPACK FOOTER //
// ../base/js/screens/Main.js